module.exports = __webpack_public_path__ + "img/4.79c3734.jpg";